//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
import userChecks from '~/mixins/userChecks';
export default {
  mixins: [ImageSrcsetMixin, userChecks],
  async fetch() {
    this.$store.commit('mxmStore/clearStream');
    let showQuery = {
      slug: 'chicas-de-holanda',
      query: this.queries.show,
    };

      const c1 = Date.parse('2025-08-15T20:30:00+02:00')
      const c2 = Date.parse('2025-08-22T20:30:00+02:00')
      const c3 = Date.parse('2025-08-29T20:30:00+02:00')
      const now = Date.now()
      
      console.log(now);

      let defaultSlug
      if (now < c1) defaultSlug = 'vamos-lekker-neuken'
        else if (now < c2) defaultSlug = 'het-charmante-alicante'
          else if (now < c3) defaultSlug = 'uno-dos-flamingos' 
            else defaultSlug = 'schaamlippen-schuimparty'    

    const resource = await this.$store.dispatch('resourcesStore/getResource', {
      slug: this.$route.params.slug || defaultSlug,
      query: this.queries.video,
      checkAccess: this.$auth.loggedIn,
    });
    const resourceId = resource.id;

    if (
      this.$auth.loggedIn &&
      resource.product === 'paid' &&
      resource.status === 'published'
    ) {
      await this.$store.dispatch('resourcesStore/checkResourceAccess', {
        id: resourceId,
        type: this.queries.video.content,
      });
    } else if (resource.product === 'free') {
      this.$store.commit('resourcesStore/setAccess', {
        access: true,
        subscription: [],
        type: 'video',
      });
    }

    let query = {
      slug: 'chicas-de-holanda',
      query: this.queries.show,
    };
    await Promise.all([
      this.$store.dispatch('resourcesStore/countResource', {
        id: query.slug,
      }),
      // this.$store.dispatch('pagesStore/getPage', 'actiechicasdeholanda'),
      this.$store.dispatch('resourcesStore/getResource', showQuery),
      this.$store.dispatch('resourcesStore/countResource', {
        id: this.$route.params.slug || defaultSlug,
      }),
    ]);
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: { queries } }) => queries,
      pages: ({ pagesStore: { pages } }) => pages,
      checkingAccess: ({ resourcesStore: { checkingAccess } }) =>
        checkingAccess,
      access: ({ resourcesStore: { access } }) => access,
      video: ({ resourcesStore: { video } }) => video,
      show: ({ resourcesStore: { show } }) => show,
      loading: ({ resourcesStore: { loading } }) => loading,
      playerOptions: ({ mxmStore: { playerOptions } }) => playerOptions,
      ppmStatus: ({ ppmStore: { ppmStatus } }) => ppmStatus,
      stream: ({ mxmStore: { stream } }) => stream,
      killStream: ({ mxmStore: { killStream } }) => killStream,
      playerState: ({ mxmStore: { playerState } }) => playerState,
      preroll: (state) => state.mxmStore.preroll,
    }),
    mainVideoIndex() {
      return this.show.video.findIndex((el) => this.video.id === el.id) + 1;
    },
    isBeforeTonight() {
      const now = new Date();
      const tonight = new Date();
      tonight.setHours(20, 30, 0, 0); // today at 20:30
      return now < tonight;
    },
    hasCredits() {
      return (
        this.$auth.loggedIn &&
        this.$auth.user &&
        this.$auth.user.user &&
        this.$auth.user.user.credits > 0
      );
    },
    userCredits() {
      return this.$auth.user && this.$auth.user.user
        ? this.$auth.user.user.credits
        : 0;
    },
    choosePlaybutton() {
      const typeOk = this.playerState.type === 'film' || !this.playerState.type;
      const accessOk = this.access.access;
      const statusOk =
        this.playerState.status !== 'exit' &&
        this.playerState.status !== 'pause';

      const hasTrailer = !!this.video?.videos?.data?.trailer?.[0]?.id;
      const shouldShowTrailer =
        hasTrailer &&
        (this.video?.status === 'planned' ||
          (!this.playerState.type && !this.access.access));

      if (shouldShowTrailer) return 'trailer';

      const hasPaidFilm =
        typeOk &&
        accessOk &&
        statusOk &&
        this.video?.videos?.data?.film?.[0]?.id;

      if (hasPaidFilm) return 'paidFilm';

      const hasFreeFilm =
        typeOk &&
        accessOk &&
        statusOk &&
        !this.video?.videos?.data?.film &&
        this.video?.videos?.data?.free_film?.[0]?.id;

      if (hasFreeFilm) return 'freeFilm';
    },
  },
  components: {
    maxXsPlayer: () => import('~/components/maxxXsPlayer'),
    Paywall: () => import('~/components/payment/module.vue'),
    videoSlider: () => import('~/components/acties/chicas/videoSlider'),
    diaryChicas: () => import('~/components/acties/chicas/diary'),
  },
  head() {
    return {
      title: this.pages.actiechicasdeholanda
        ? this.pages.actiechicasdeholanda.seo.title
        : "Chica's de Holanda | hete sex vakantie | Meiden van Holland",
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: this.pages.actiechicasdeholanda
            ? this.pages.actiechicasdeholanda.seo.title
            : "Chica's de Holanda | hete sex vakantie | Meiden van Holland",
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.pages.actiechicasdeholanda
            ? this.pages.actiechicasdeholanda.seo.title
            : "Chica's de Holanda | hete sex vakantie | Meiden van Holland",
        },
        {
          hid: 'description',
          name: 'description',
          content: this.pages.actiechicasdeholanda
            ? this.pages.actiechicasdeholanda.seo.description
            : "Vamos, neuken maar in nieuwe vakantie sex serie Chica's de Holanda. Kijk aflevering 1 nu helemaal gratis! Goedlachse Cheffie, sexy milf Melody en Haagse Lorena zijn 4 dagen in Spanje, wippen langs hete vriendinnen en maken de geilste avonturen mee.",
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.pages.actiechicasdeholanda
            ? this.pages.actiechicasdeholanda.seo.description
            : "Vamos, neuken maar in nieuwe vakantie sex serie Chica's de Holanda. Kijk aflevering 1 nu helemaal gratis! Goedlachse Cheffie, sexy milf Melody en Haagse Lorena zijn 4 dagen in Spanje, wippen langs hete vriendinnen en maken de geilste avonturen mee.",
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content: process.env.FE_URL + '/acties/chicas-de-holanda',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.pages.actiechicasdeholanda
            ? this.pages.actiechicasdeholanda.seo.keywords
            : 'meiden van holland, chicas de holanda, lorena sex, melody pleasure, vakantie sex, gratis sexfilm, sexfilms',
        },
      ],
    };
  },
  data() {
    return {};
  },
  watch: {
    access: function () {
      this.$auth.fetchUser();
      this.checkPaywall();
      console.log('access has changed so refresh the user');
    },
    preroll: function (newValue, oldValue) {
      if (newValue === 'shown') {
        this.loadFreeFilm(this.video.videos.data.free_film[0].id);
      }
    },
    stream: function () {
      if (
        this.stream.location == 'sexfilm' &&
        this.stream.ITEM &&
        this.stream.ITEM.LINKS
      ) {
        if (
          this.video.images &&
          this.video.images.data &&
          this.video.images.data.thumb &&
          this.video.images.data.thumb[0]
        ) {
          var thumb = this.$config.cdn + this.video.images.data.thumb[0].path;
        } else {
          var thumb = this.$config.cdn + this.$config.errorimg;
        }
        let playerOptions = {
          autoplay: true,
          poster: thumb,
        };
        this.$store.commit('mxmStore/updatePlayerOptions', playerOptions);
        this.$store.commit('mxmStore/setPlayerType', this.stream.type);

        var phone_stream_id = this.getCookie('phone_stream_id');
        if (phone_stream_id) {
          // PPM access so we should check status with interval
          // Interval is handled by mxmStore
          var dataObj = {
            action: 'update',
            stream_id: phone_stream_id,
          };
          this.$store.dispatch('mxmStore/startUpdateStream', dataObj);
        }
      }
    },
    killStream: function () {
      var phone_stream_id = this.getCookie('phone_stream_id');
      if (this.killStream == true && phone_stream_id) {
        this.doKillStream('phone');
      }
    },
    video: function () {
      this.checkPaywall();
      var phone_stream_id = this.getCookie('phone_stream_id');
      if (phone_stream_id) {
        this.$store.dispatch(
          'ppmStore/checkPhoneStreamStatus',
          phone_stream_id
        );
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch('mxmStore/stopUpdateStream');
    this.$store.commit('resourcesStore/resetAccess');
  },
  methods: {
    playAudio(el, audioUrls) {
      const previousAudio = document.querySelector('.custom-audio-tag');
      if (previousAudio) {
        previousAudio.pause();
        previousAudio.currentTime = 0;
        previousAudio.remove();
      }

      if (!Array.isArray(audioUrls) || audioUrls.length === 0) return;

      const randomIndex = Math.floor(Math.random() * audioUrls.length);
      const audioUrl = this.$config.cdn + audioUrls[randomIndex].path;

      const newAudio = document.createElement('audio');
      newAudio.src = audioUrl;
      newAudio.className = 'custom-audio-tag';
      newAudio.volume = 0.5;
      newAudio.style.display = 'none';

      el.currentTarget.appendChild(newAudio);

      newAudio.play().catch((err) => {
        console.warn('Audio playback failed:', err);
      });
    },
    checkPaywall() {
      if (
        this.$route.params.slug != this.video.slug ||
        this.$route.query.paywall === 'active'
      ) {
        return;
      }
      if (
        !this.access.access &&
        !this.ppmStatus.action &&
        window.innerWidth < 1200
      ) {
        this.$store.commit('paywallStore/setView', 'active');
        this.$store.commit('paywallStore/setStep', 0);
      } else {
        this.$store.commit('paywallStore/setView', 'closed');
      }
    },
    loadTrailer(videoId) {
      this.$store.commit('mxmStore/clearStream');
      var dataObj = {};
      dataObj.video_id = videoId;
      dataObj.resource_id = this.video.id;
      dataObj.product_type = 'free';
      dataObj.type = 'trailer';
      dataObj.location = 'sexfilm';
      this.$store.dispatch('mxmStore/getStream', dataObj);
    },
    async loadFreeFilm(videoId) {
      this.$store.commit('mxmStore/clearStream');
      if (this.stream && this.stream.id && this.stream.type == 'free_film') {
        return this.$store.commit('mxmStore/setPlayerStatus', 'playing');
      }
      if (
        (this.video.product === 'free' &&
          this.$auth.loggedIn &&
          !this.hasDirectSubscription() &&
          this.preroll != 'shown') ||
        (this.video.product === 'free' &&
          !this.$auth.loggedIn &&
          this.preroll != 'shown')
      ) {
        if (
          this.video.preroll &&
          this.video.preroll.length &&
          this.video.preroll[0].videos &&
          this.video.preroll[0].videos.data &&
          this.video.preroll[0].videos.data.preroll &&
          this.video.preroll[0].videos.data.preroll.length
        ) {
          const randomIndex = Math.floor(
            Math.random() * this.video.preroll.length
          );
          var dataObj = {
            video_id: this.video.preroll[0].videos.data.preroll[0].id,
            resource_id: this.video.preroll[0].id,
            href: this.video.preroll[0].extra.href,
            target: this.video.preroll[0].extra.target,
            type: 'preroll',
            location: 'sexfilm',
            product_type: 'free',
          };
          return this.$store.dispatch('mxmStore/getStream', dataObj);
        }
      }

      var dataObj = {
        video_id: videoId,
        resource_id: this.video.id,
        type: 'free_film',
        location: 'sexfilm',
        product_type: 'free',
      };
      if (this.$store.state.auth.loggedIn) {
        dataObj.user_id = this.$auth.user.id;
      }
      this.$store.dispatch('mxmStore/getStream', dataObj);
    },
    loadPaidFilm(videoId) {
      this.$store.commit('mxmStore/clearStream');
      this.kind = false;
      if (this.stream && this.stream.id && this.stream.type == 'film') {
        return this.$store.commit('mxmStore/setPlayerStatus', 'playing');
      }
      var dataObj = {
        video_id: videoId,
        resource_id: this.video.id,
        type: 'film',
        location: 'sexfilm',
        product_type: 'paid',
      };
      if (this.$store.state.auth.loggedIn) {
        dataObj.user_id = this.$store.state.auth.user.id;
      }

      var phone_stream_id = this.getCookie('phone_stream_id');
      if (phone_stream_id) {
        dataObj.phone_stream_id = phone_stream_id;
        dataObj.subscription_id = 3;
        return this.$store.dispatch('mxmStore/getStream', dataObj);
      } else {
        dataObj.subscription_id =
          this.access.subscription && this.access.subscription.id
            ? this.access.subscription.id
            : 1;
        return this.$store.dispatch('mxmStore/getStream', dataObj);
      }
    },
    loadVideoByAccess(videoData) {
      const videoMap = {
        trailer: [videoData.trailer, this.loadTrailer],
        paidFilm: [videoData.film, this.loadPaidFilm],
        freeFilm: [videoData.free_film, this.loadFreeFilm],
      };

      const [videoList, action] = videoMap[this.choosePlaybutton] || [];

      const id = videoList?.[0]?.id;

      if (id) {
        action(id);
      }
    },
    setStatus(status) {
      this.$store.commit('mxmStore/setPlayerStatus', status);
    },
    activatePaywall() {
      this.$store.commit('paywallStore/setView', 'active');
      this.$store.commit('modalStore/setModal', false);
    },
    doKillStream(type) {
      if (type == 'phone') {
        var alertObj = [];
        alertObj.type = 'warning';
        alertObj.message =
          'De verbinding is verbroken. Verder kijken? Bel dan opnieuw.';
        this.$store.commit('alertStore/setAlert', alertObj, { root: true });
        document.cookie =
          'phone_stream_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        this.$store.commit('resourcesStore/setAccess', {
          access: false,
          is_free: false,
          subscription: [],
        });
        this.$store.commit('mxmStore/clearStream');
        this.$store.commit('ppmStore/setPpmStatus', false);
      }
    },
  },
};
